<template>
    <div class="song-panel">
        <transition-group name="fadeUp">
            <div v-for="(podcast, index) in podcasts" v-bind:key="index" class="list-item">
                <div class="song-bar">
                    <div class="podcast-icon">

                        <div class="radio-icon">
                            <svg-icon icon="on_air" @click.native="pausePodcast(podcast)"
                                      v-if="player.playing && player.id && player.id === podcast.id && player.channel === podcast.channel_id"/>
                        </div>

                        <svg-icon icon="play_podcast-01" @click.native="playPodcast(podcast, index)"
                                  v-if="player.channel !== currentChannelId || player.id !== podcast.id || !player.playing"/>

                    </div>
                    <div class="podcast-info">
                        <div class="podcast-info-left">

                            <viewer :images="[podcast.cover]"
                                    :options="{navbar:false, title:false, toolbar:false, movable:false, zoomable:false}" >
                                <img class="album" :src="podcast.cover" alt="album">
                            </viewer>

                            <div class="song-info">
                                <p class="album-name text">{{podcast.artist}}</p>
                                <p class="song-name text">{{podcast.title}}</p>
                                <p class="time text">{{podcast.duration}}</p>
                            </div>
                        </div>
                        <div class="podcast-info-right">
                            <a class="load text" @click="download(podcast)">Download</a>
                        </div>
                    </div>
                </div>
            </div>
        </transition-group>
    </div>
</template>

<script>

  import SvgIcon from '../layout/SvgIcon'

  export default {
    components: {
      SvgIcon
    },

    props: {
      podcasts: null,
      player: {
        playing: false,
        id: null,
        channel: 1,
      },
      currentChannelId: null,

    },



    methods: {
      playPodcast (podcast, index) {
        this.stopAllTracks()
        let audio = document.getElementById('radio-' + podcast.id)

        if(!audio){
          let div = document.getElementById('podcast-audio')
          div.innerHTML = "<audio id='radio-"+ podcast.id +"' src='/storage/podcasts/channels/" + podcast.channel_id + "/" + podcast.name + "'></audio>"

          audio = document.getElementById('radio-' + podcast.id)
        }

        audio.play()
        this.player.playing = true
        this.player.id = podcast.id
        this.player.channel = podcast.channel_id
        this.sendPlayerEvent(podcast)

        this.setAudioEvents(audio, podcast, index)
      },

      setAudioEvents (audio, podcast, index) {
        let self = this

        audio.onended = function () {
          podcast = self.podcasts[index + 1] ? self.podcasts[index + 1] : self.podcasts[0]
          self.playPodcast(podcast)
        }

        audio.addEventListener("timeupdate", function() {
          let timeleft = document.getElementById('timeleft'),
            progress = document.getElementById("player-progress"),
            currentTime = parseInt(audio.currentTime),
            duration = parseInt(audio.duration),
            timeLeft = duration - currentTime,
            s, m, h


          s = timeLeft % 60
          m = Math.floor( timeLeft / 60 ) % 60
          h = Math.floor( timeLeft / 60 / 60 ) % 60

          s = s < 10 ? "0"+s : s
          m = m < 10 ? "0"+m : m
          h = h > 0 ? h+":" : ''

          timeleft.textContent = "- "+ h + m + ":" + s
          progress.style.width = currentTime/duration*100 + '%'
        });
      },

      stopAllTracks () {
        let sounds = document.getElementsByTagName('audio')
        for (let i = 0; i < sounds.length; i++)
          sounds[i].pause()
      },

      pausePodcast (podcast) {
        let audio = document.getElementById('radio-' + podcast.id)
        audio.pause()
        this.player.id = null
        this.player.playing = false

        document.getElementById("timeleft").style.display = 'none'
        document.getElementById("player-progress").style.display = 'none'
      },

      sendPlayerEvent (podcast) {
        this.$root.$emit('radio-play', {
          player: this.player,
          podcast: podcast
        })
      },

      listenPlayerUpdate () {
        this.$root.$on('radio-play', (item) => {
          let display = ''
          if (item.status || item.radio)
             display = 'none'
          if (item.podcast)
             display = 'block'

          document.getElementById('timeleft').style.display = display
          document.getElementById('player-progress').style.display = display

          if(item.player.id){
            this.player = item.player
          }
        })
      },

      download (podcast) {
        if(podcast.download_link){
          this.$modal.show('download-link',{track: podcast})
        } else{
          let link = document.createElement("a");
          link.download = podcast.artist + ' - ' + podcast.title;
          link.href = '/storage/podcasts/channels/' + podcast.channel_id + '/'  + podcast.name;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          link = '';
        }
      },
    },

    mounted () {
      this.listenPlayerUpdate()
    }

  }
</script>

<style>
    .podcast-pause{
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/podcast/SongPanel.vue